import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { StompConfig, StompService } from '@stomp/ng2-stompjs';
import { Message } from '@stomp/stompjs';

@Injectable()
export class NotifyPushMessageService {
    private subject = new Subject<any>();
    private wsSubject = new Subject<any>();

    constructor(private _stompService: StompService) {
        this._stompService.disconnect();
        this.initializeWebSocketConnection();
    }

    notify(message: any) {
        this.subject.next(message);
    }

    clearNotification() {
        this.subject.next();
    }

    getNotification(): Observable<any> {
        return this.subject.asObservable();
    }

    initializeWebSocketConnection() {
        let stomp_subscription = this._stompService.subscribe('/topic/public');

        stomp_subscription.map((message: Message) => {
            return message.body;
        }).subscribe((msg_body: string) => {
            console.log(`Received: ${msg_body}`);
            let response = JSON.parse(msg_body);
            this.wsSubject.next(response);
         });
    }

    clearWSNotification() {
        this.wsSubject.next();
    }

    getWSNotification(): Observable<any> {
        return this.wsSubject.asObservable();
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/notify-push-message.service.ts